export enum SourceEnum {
  B2G_CONTABILIDADE = 'B2gContabilidade',
  NIKOLAY = 'Nikolay',
  LCC = 'LCC',
  ACOMA = 'Acoma',
  B2B = 'B2B',
  VML = 'VML',
  DEFAULT = 'Default',
  FORTTIUS = 'Forttius',
  ARAUJO_SOARES = 'AraujoSoares',
  APOIO_EMPRESAS = 'ApoioEmpresas',
  AVANCECRED = 'avancecred',
}
